import { render, staticRenderFns } from "./OverviewSidebar.vue?vue&type=template&id=130a0412&scoped=true&"
import script from "./OverviewSidebar.vue?vue&type=script&lang=js&"
export * from "./OverviewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSidebar.vue?vue&type=style&index=0&id=130a0412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a0412",
  null
  
)

export default component.exports